/* VAEN v6 · global behaviours — header, mobile menu, seals, footer, collection, home */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------------- header ---------------- */
  function initHeader() {
    var h = $('[data-vh]'); if (!h || h.__v) return; h.__v = 1;
    var root = document.documentElement, bar = $('.vh__bar', h);
    function setH() { var v = bar.offsetHeight; root.style.setProperty('--vh-h', v + 'px'); root.style.setProperty('--header-height', v + 'px'); }
    setH(); addEventListener('resize', setH);
    var hero = h.classList.contains('vh--overlay');
    var tick = false;
    function onScroll() {
      tick = false; var y = scrollY;
      var was = h.classList.contains('is-scrolled'); h.classList.toggle('is-scrolled', y > 24); if (was !== (y > 24)) setTimeout(setH, 560);
      if (hero) { var hh = document.querySelector('[data-h6-hero]'); var lim = hh ? hh.offsetTop + hh.offsetHeight - 90 : Math.max(60, innerHeight * 0.55); h.classList.toggle('is-solid', y > lim); }
    }
    addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
    /* mega */
    var open = null, tOut = 0, tIn = 0;
    function show(it) {
      clearTimeout(tOut);
      if (open === it) return;
      if (open) { open.classList.remove('is-open'); var a0 = $('.vh__lnk', open); if (a0) a0.setAttribute('aria-expanded', 'false'); }
      open = it;
      if (it) { it.classList.add('is-open'); var a = $('.vh__lnk', it); if (a) a.setAttribute('aria-expanded', 'true'); }
      h.classList.toggle('is-mega', !!it);
    }
    function hide() { clearTimeout(tIn); tOut = setTimeout(function () { show(null); }, 160); }
    $$('.vh__item', h).forEach(function (it) {
      var has = it.classList.contains('has-mega');
      it.addEventListener('mouseenter', function () { clearTimeout(tIn); clearTimeout(tOut); if (!has) { tOut = setTimeout(function () { show(null); }, 60); return; } tIn = setTimeout(function () { show(it); }, open ? 0 : 70); });
      it.addEventListener('mouseleave', hide);
      if (!has) return;
      var lnk = $('.vh__lnk', it);
      lnk.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { if (open !== it) { e.preventDefault(); show(it); } } if (e.key === 'Escape') show(null); });
      it.addEventListener('focusout', function (e) { if (!it.contains(e.relatedTarget)) hide(); });
      /* touch-capable desktops: first tap opens */
      lnk.addEventListener('click', function (e) { if (!fine && open !== it) { e.preventDefault(); show(it); } });
      var img = $('[data-vh-img]', it), cap = $('[data-vh-cap]', it), num = $('[data-vh-n]', it), cur = img ? img.getAttribute('src') : '';
      $$('.vh__mega-l a[data-img]', it).forEach(function (a) {
        a.addEventListener('mouseenter', function () {
          if (cap) cap.textContent = a.dataset.cap || ''; if (num) num.textContent = a.dataset.n || '';
          var src = a.dataset.img; if (!img || !src || src === cur) return; cur = src;
          var pre = new Image(); pre.onload = function () { img.classList.add('is-out'); setTimeout(function () { img.src = src; img.classList.remove('is-out'); }, 180); }; pre.src = src;
        });
      });
    });
    var veil = $('[data-vh-veil]', h); if (veil) veil.addEventListener('mouseenter', function () { show(null); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { show(null); closeM(); } });
    /* mobile menu */
    var m = $('[data-vh-menu]', h), btn = $('[data-vh-open]', h);
    if (m && m.parentElement !== document.body) document.body.appendChild(m);
    function openM() { if (!m) return; m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); root.classList.add('vh-lock'); btn && btn.setAttribute('aria-expanded', 'true'); var x = $('[data-vh-close]', m); x && x.focus({ preventScroll: true }); }
    function closeM() { if (!m || !m.classList.contains('is-open')) return; m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); root.classList.remove('vh-lock'); btn && btn.setAttribute('aria-expanded', 'false'); }
    btn && btn.addEventListener('click', openM);
    m && $('[data-vh-close]', m).addEventListener('click', closeM);
    m && $$('[data-vh-acc]', m).forEach(function (b) {
      b.addEventListener('click', function () {
        var row = b.closest('.vh-m__row'), on = !row.classList.contains('is-open');
        $$('.vh-m__row.is-open', m).forEach(function (r) { if (r !== row) { r.classList.remove('is-open'); $('[data-vh-acc]', r).setAttribute('aria-expanded', 'false'); } });
        row.classList.toggle('is-open', on); b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    });
    m && $$('[data-pulse-search-open]', h).forEach(function (b) { b.addEventListener('click', closeM); });
    addEventListener('resize', function () { if (innerWidth >= 990) closeM(); });
  }

  /* ---------------- footer ---------------- */
  function initFooter() {
    $$('[data-vf]').forEach(function (f) {
      if (f.__v) return; f.__v = 1;
      $$('[data-vf-toggle]', f).forEach(function (b) { b.addEventListener('click', function () { if (matchMedia('(min-width:750px)').matches) return; var c = b.closest('[data-vf-col]'), on = !c.classList.contains('is-open'); c.classList.toggle('is-open', on); b.setAttribute('aria-expanded', on); }); });
      var t = $('[data-vf-top]', f); if (t) t.addEventListener('click', function () { scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
      var mk = $('[data-vf-mark]', f);
      if (mk) {
        if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { mk.classList.add('is-in'); io.disconnect(); } }); }, { threshold: .3 }); io.observe(mk); } else mk.classList.add('is-in');
        var g = $('radialGradient', mk), svg = $('.vn-logo', mk);
        if (g && svg && fine && !reduce) {
          var tx = 159, ty = 50, cx = 159, cy = 50, raf = 0;
          function loop() { cx += (tx - cx) * .12; cy += (ty - cy) * .12; g.setAttribute('cx', cx.toFixed(1)); g.setAttribute('cy', cy.toFixed(1)); raf = (Math.abs(tx - cx) + Math.abs(ty - cy) > .3) ? requestAnimationFrame(loop) : 0; }
          mk.addEventListener('pointermove', function (e) { var r = svg.getBoundingClientRect(); tx = (e.clientX - r.left) / r.width * 318; ty = (e.clientY - r.top) / r.height * 100; if (!raf) raf = requestAnimationFrame(loop); });
          mk.addEventListener('pointerleave', function () { tx = 159; ty = 50; if (!raf) raf = requestAnimationFrame(loop); });
        }
      }
    });
  }

  /* ---------------- collection header ---------------- */
  function initCollection() {
    $$('[data-vc6]').forEach(function (sec) {
      if (sec.__v) return; sec.__v = 1;
      requestAnimationFrame(function () { setTimeout(function () { sec.classList.add('is-ready'); }, 60); });
      var rail = $('[data-vc6-rail]', sec); if (!rail) return;
      var prog = $('[data-vc6-prog]', sec), prev = $('[data-vc6-prev]', sec), next = $('[data-vc6-next]', sec), ctrl = $('.vc6__ctrl', sec);
      function upd() {
        var max = rail.scrollWidth - rail.clientWidth;
        if (ctrl) ctrl.classList.toggle('is-static', max < 4);
        var p = max > 0 ? rail.scrollLeft / max : 1, vis = rail.clientWidth / rail.scrollWidth;
        if (prog) prog.style.setProperty('--p', Math.min(1, vis + p * (1 - vis)).toFixed(3));
        if (prev) prev.disabled = rail.scrollLeft < 4; if (next) next.disabled = rail.scrollLeft > max - 4;
      }
      function step(d) { var c = $('[data-vc6-card]', rail); var w = c ? c.getBoundingClientRect().width + 14 : 300; rail.scrollBy({ left: d * w * (innerWidth > 989 ? 2 : 1), behavior: reduce ? 'auto' : 'smooth' }); }
      prev && prev.addEventListener('click', function () { step(-1); }); next && next.addEventListener('click', function () { step(1); });
      rail.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true }); addEventListener('resize', upd); upd();
      var cur = $('.vc6__c.is-cur', rail); if (cur && cur.offsetLeft > rail.clientWidth * .6) rail.scrollLeft = cur.offsetLeft - 20;
      /* drag to scroll (desktop) */
      if (fine) {
        var down = false, sx = 0, sl = 0, moved = false;
        rail.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft; });
        addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 5) { moved = true; rail.style.scrollSnapType = 'none'; rail.scrollLeft = sl - dx; } });
        addEventListener('pointerup', function () { if (!down) return; down = false; rail.style.scrollSnapType = ''; });
        rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
        rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }
      /* 3D tilt */
      if (fine && !reduce) $$('[data-vc6-tilt]', rail).forEach(function (t) {
        t.addEventListener('pointermove', function (e) {
          var r = t.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
          t.style.setProperty('--ry', (x * 9).toFixed(2) + 'deg'); t.style.setProperty('--rx', (-y * 9).toFixed(2) + 'deg');
          t.style.setProperty('--tx', (-x * 14).toFixed(1) + 'px'); t.style.setProperty('--ty', (-y * 14).toFixed(1) + 'px');
          t.style.setProperty('--sx', ((x + .5) * 100).toFixed(0) + '%'); t.style.setProperty('--sy', ((y + .5) * 100).toFixed(0) + '%');
        });
        t.addEventListener('pointerleave', function () { ['--rx', '--ry', '--tx', '--ty'].forEach(function (k) { t.style.removeProperty(k); }); });
      });
    });
  }

  /* ---------------- live Toronto clock ---------------- */
  function clocks() {
    var els = $$('[data-vn-clock]'); if (!els.length) return;
    var fmt; try { fmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', hour: 'numeric', minute: '2-digit', hour12: true, timeZoneName: 'short' }); } catch (e) { return; }
    function run() { var t = fmt.format(new Date()).replace(/\./g, '').toUpperCase(); els.forEach(function (el) { el.textContent = (el.dataset.vnClock || 'Toronto') + ' · ' + t; }); }
    run(); setInterval(run, 20000);
  }

  /* ---------------- reveal ---------------- */
  function reveal() {
    var els = $$('[data-v6-in]:not(.is-in)'); if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    els.forEach(function (e) { io.observe(e); });
  }

  window.VAEN6 = window.VAEN6 || {};
  var hooks = window.VAEN6.hooks = window.VAEN6.hooks || [];
  function init() { initHeader(); initFooter(); initCollection(); clocks(); reveal(); hooks.forEach(function (f) { try { f($, $$, reduce, fine); } catch (e) { console.error(e); } }); }
  window.VAEN6.reveal = reveal;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* ═══════════ VAEN v8 · page transition controller ═══════════ */
(function () {
  var h = document.documentElement, ld = document.getElementById('vn-ld');
  if (!ld || (window.Shopify && Shopify.designMode)) { h.classList.remove('vn-ld-in', 'vn-ld-first'); return; }
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var veil = ld.querySelector('.vn-ld__veil'), ls = [].slice.call(ld.querySelectorAll('.vn-ld__l')), num = ld.querySelector('[data-vn-ld-n]'), raf = 0, p = 1, busy = false;
  var EZ = 'cubic-bezier(.76,0,.24,1)', EO = 'cubic-bezier(.16,1,.3,1)';
  function setP(v) { p = v; ld.style.setProperty('--p', v.toFixed(4)); ls.forEach(function (l, i) { var q = Math.max(0, Math.min(1, v * 1.28 - i * .07)); l.style.setProperty('--p', q.toFixed(4)); }); if (num) { var n = Math.round(v * 100); num.textContent = n >= 100 ? '100' : ('0' + n).slice(-2); } }
  function anim(el, kf, o) { try { return el.animate(kf, o); } catch (e) { return null; } }
  function pour(to, dur, cb) {
    cancelAnimationFrame(raf); var from = p, t0 = performance.now();
    (function step(t) { var k = Math.min(1, (t - t0) / dur); k = 1 - Math.pow(1 - k, 3); setP(from + (to - from) * k); if (k < 1) raf = requestAnimationFrame(step); else if (cb) cb(); })(t0);
  }
  function creep() { cancelAnimationFrame(raf); (function step() { setP(p + (0.97 - p) * 0.018); raf = requestAnimationFrame(step); })(); }

  /* ── arrival: letters fold flat, accent stretches into a line, veil lifts ── */
  function reveal() {
    if (!h.classList.contains('vn-ld-in')) return;
    var first = h.classList.contains('vn-ld-first');
    var go = function () {
      ls.forEach(function (l, i) {
        var acc = l.classList.contains('vn-ld__l--acc');
        anim(l, acc ? [{ transform: 'none', opacity: 1 }, { transform: 'scaleX(1.25)', opacity: 1, offset: .45 }, { transform: 'scaleX(0)', opacity: 0 }]
                    : [{ transform: 'rotateX(0deg)', opacity: 1 }, { transform: 'rotateX(-92deg)', opacity: 0 }],
          { duration: acc ? 1000 : 780, delay: 60 * i, easing: EZ, fill: 'forwards' });
      });
      anim(ld.querySelector('.vn-ld__line'), [{ transform: 'scaleX(1)', opacity: 1 }, { transform: 'scaleX(0)', opacity: 0 }], { duration: 700, delay: 120, easing: EZ, fill: 'forwards', transformOrigin: 'right' });
      anim(ld.querySelector('.vn-ld__k'), [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(8px)' }], { duration: 420, easing: EZ, fill: 'forwards' });
      var a = anim(veil, [{ clipPath: 'inset(0 0 0 0)' }, { clipPath: 'inset(0 0 100% 0)' }], { duration: 1050, delay: 420, easing: EZ, fill: 'forwards' });
      var done = function () { h.classList.remove('vn-ld-in', 'vn-ld-first'); [veil].concat(ls).forEach(function (e) { e.getAnimations && e.getAnimations().forEach(function (x) { x.cancel(); }); }); ld.querySelectorAll('.vn-ld__line,.vn-ld__k').forEach(function (e) { e.getAnimations && e.getAnimations().forEach(function (x) { x.cancel(); }); }); };
      if (a) a.onfinish = done; else done();
      setTimeout(done, 2200);
    };
    if (first && !RM) { setP(0); pour(1, 900, function () { setTimeout(go, 120); }); }
    else { setP(1); var wait = function () { requestAnimationFrame(function () { setTimeout(go, 90); }); }; if (document.readyState === 'complete') wait(); else { var t = setTimeout(wait, 650); addEventListener('load', function () { clearTimeout(t); wait(); }, { once: true }); } }
  }

  /* ── departure: veil rises, letters unfold, wordmark pours while the next page loads ── */
  function leave(url) {
    if (busy) return; busy = true;
    h.classList.add('vn-ld-go'); setP(0);
    anim(veil, [{ clipPath: 'inset(100% 0 0 0)' }, { clipPath: 'inset(0 0 0 0)' }], { duration: 620, easing: EZ, fill: 'forwards' });
    ls.forEach(function (l, i) { anim(l, [{ transform: 'rotateX(92deg)', opacity: 0 }, { transform: 'rotateX(0deg)', opacity: 1 }], { duration: 760, delay: 160 + 55 * i, easing: EO, fill: 'forwards' }); });
    anim(ld.querySelector('.vn-ld__k'), [{ opacity: 0 }, { opacity: 1 }], { duration: 400, delay: 300, fill: 'forwards' });
    pour(.62, 620, creep);
    try { sessionStorage.setItem('vn-ld', '1'); } catch (e) {}
    setTimeout(function () { location.href = url; }, 600);
    setTimeout(function () { reset(); }, 9000);
  }
  function reset() { busy = false; cancelAnimationFrame(raf); h.classList.remove('vn-ld-go', 'vn-ld-in', 'vn-ld-first'); [veil].concat(ls).forEach(function (e) { e.getAnimations && e.getAnimations().forEach(function (x) { x.cancel(); }); }); try { sessionStorage.removeItem('vn-ld'); } catch (e) {} }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || RM) return;
    var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
    if (a.target && a.target !== '_self') return; if (a.hasAttribute('download') || a.hasAttribute('data-no-ld')) return;
    var raw = a.getAttribute('href'); if (!raw || raw[0] === '#' || /^(mailto|tel|sms|javascript):/i.test(raw)) return;
    var u; try { u = new URL(a.href, location.href); } catch (x) { return; }
    if (u.origin !== location.origin) return;
    if (u.pathname === location.pathname && u.search === location.search) return;
    if (/\/(cart\/(add|change|clear|update)|account\/logout)/.test(u.pathname)) return;
    if (a.closest('[data-no-ld], .shopify-section-group-overlay-group cart-drawer quantity-input')) return;
    e.preventDefault(); leave(u.href);
  });
  addEventListener('pageshow', function (e) { if (e.persisted) reset(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal); else reveal();
})();

/* VAEN v8 · keep cart drawer empty-state class in sync after ajax renders */
(function () {
  function sync() { var cd = document.querySelector('cart-drawer.vcd'); if (!cd) return; var empty = !!cd.querySelector('.vcd-empty'); cd.classList.toggle('is-empty', empty); var it = cd.querySelector('cart-drawer-items'); if (it) it.classList.toggle('is-empty', empty); }
  function boot() { var cd = document.querySelector('cart-drawer.vcd'); if (!cd) return; new MutationObserver(function () { requestAnimationFrame(sync); }).observe(cd, { childList: true, subtree: true }); sync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
